<template>
    <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-100">
            <thead class="bg-gray-50">
                <tr>
                    <SortableTh :label="t('vue.id')" field="id" />
                    <SortableTh :label="t('vue.kiosk_da_time')" field="time" />
                    <SortableTh
                        :label="t('vue.kiosk_da_al_team')"
                        field="team_name"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_al_user')"
                        field="user_email"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_al_entity_type')"
                        field="entity_type"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_al_event_code')"
                        field="event_code"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_al_operation_type')"
                        field="operation_type"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_al_source')"
                        field="source"
                    />
                    <SortableTh
                        :label="t('vue.kiosk_da_al_message')"
                        field="message"
                    />
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
                <tr
                    v-for="log in items"
                    :key="log.id"
                    class="hover:bg-gray-50/60"
                >
                    <td class="px-4 py-3 font-mono text-xs text-gray-400">
                        {{ log.id }}
                    </td>
                    <td
                        class="whitespace-nowrap px-4 py-3 text-sm text-gray-600"
                    >
                        {{ log.time ?? "—" }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        <template v-if="log.team_name">
                            <a
                                v-if="log.team_kiosk_url"
                                :href="log.team_kiosk_url"
                                target="_blank"
                                class="text-indigo-600 hover:underline"
                            >
                                {{ log.team_name }}
                            </a>
                            <span v-else>{{ log.team_name }}</span>
                        </template>
                        <span v-else class="text-gray-400">—</span>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        <template v-if="log.user_email">
                            <a
                                v-if="log.user_kiosk_url"
                                :href="log.user_kiosk_url"
                                target="_blank"
                                class="text-indigo-600 hover:underline"
                            >
                                {{ log.user_email }}
                            </a>
                            <span v-else>{{ log.user_email }}</span>
                        </template>
                        <span v-else class="text-gray-400">—</span>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        <span
                            class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700"
                        >
                            {{ log.entity_type }}
                        </span>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        <span
                            v-if="log.event_code"
                            class="inline-flex items-center rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700"
                        >
                            {{ log.event_code }}
                        </span>
                        <span v-else class="text-gray-400">—</span>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        <span
                            class="inline-flex items-center rounded-full bg-purple-50 px-2 py-0.5 text-xs font-medium text-purple-700"
                        >
                            {{ log.operation_type }}
                        </span>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        <span v-if="log.source" class="text-xs text-gray-500">
                            {{ log.source }}
                        </span>
                        <span v-else class="text-gray-400">—</span>
                    </td>
                    <td
                        class="max-w-xs truncate px-4 py-3 text-xs text-gray-500"
                        :title="log.message ?? undefined"
                    >
                        {{ log.message ?? "—" }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" setup>
import { useTranslations } from "@/composables/useTranslations";
import type { IActivityLogItem } from "../../types";

const { t } = useTranslations();

defineProps<{
    items: IActivityLogItem[];
}>();
</script>
